import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateLookupComponent } from './date-lookup.component';
import { FormsModule } from '@angular/forms';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule
  ],
  declarations: [DateLookupComponent],
  exports: [DateLookupComponent]
})
export class DateLookupModule { }
